import { useJourneyAppletsBySessionCodeQuery } from '@innovamat/glow-api-client';
import type { JourneyUnblockedApplet } from '../modules/journey-unblocked-applet';

type Props = {
  enabled?: boolean;
  language: string;
  region: string;
  sessionCode: string;
};

type UseJourneyUnblockedApplets = {
  applets: JourneyUnblockedApplet[] | undefined;
  error: Error | null;
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  isPending: boolean;
};

function useJourneyUnblockedApplets({
  language,
  region,
  sessionCode,
  enabled = true,
}: Props): UseJourneyUnblockedApplets {
  const { data, error, isError, isFetching, isLoading, isPending } =
    useJourneyAppletsBySessionCodeQuery(
      {
        sessionCode,
        locale: language,
        region,
      },
      { enabled: enabled && !!sessionCode && !!language && !!region }
    );

  return {
    applets:
      (data?.journeyAppletsBySessionCode?.filter((applet) =>
        Boolean(applet?.data)
      ) as JourneyUnblockedApplet[]) || undefined,
    error: error as Error | null,
    isError,
    isFetching,
    isLoading,
    isPending,
  };
}

export { useJourneyUnblockedApplets };
